module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_13.d46e4c65.jpeg";